<div class="main-content-url" *ngIf="!isRedirect && !showShareCard">
  <form [formGroup]="urlForm" (ngSubmit)="onSubmit(botGuard)" class="tool-box">
    <input
      id="url"
      name="url"
      type="text"
      formControlName="url"
      class="form-control text-url-input"
      placeholder="Paste your long URL here..."
      title="Paste your long URL here..."
    />

    <div
      *ngIf="
        urlForm.get('url')?.invalid &&
        (urlForm.get('url')?.touched || urlForm.get('url')?.dirty)
      "
      class="validation-error"
    >
      <div *ngIf="urlForm.get('url')?.errors?.['required']">
        URL is required.
      </div>
      <div *ngIf="urlForm.get('url')?.errors?.['pattern']">
        Please enter a valid URL.
      </div>
    </div>
    <div class="controls">
      <div class="control-row">
        <div class="control-group">
          <label for="expiry-select">Expiry Time:</label>
          <select id="expiry-select" formControlName="expiryTime">
            <option
              *ngFor="let expiryTime of expiryTimes"
              [value]="expiryTime.value"
            >
              {{ expiryTime.text }}
            </option>
          </select>
        </div>
        <div class="control-group">
          <app-custom-link
            #customLink
            (availabilityChange)="onSlugAvailabilityChange($event)"
            (slugChange)="onSlugChange($event)"
          ></app-custom-link>
        </div>
      </div>
      <app-additional-options
        [isExpanded]="isExpanded"
        (toggle)="toggleAdditionalOptions()"
      >
        <app-one-time-toggle
          [isOneTimeView]="isOneTimeView"
          (isOneTimeViewChange)="isOneTimeView = $event"
        ></app-one-time-toggle>
        <app-pin-toggle></app-pin-toggle>
      </app-additional-options>
      <app-bot-guard #botGuard></app-bot-guard>
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="urlForm.invalid || isSlugAvailable === false"
      >
        Shorten URL
      </button>
    </div>
  </form>
  <app-loader-overlay
    *ngIf="loading"
    [message]="'Processing...'"
  ></app-loader-overlay>
</div>

<div class="share-card-wrapper" *ngIf="showShareCard && shortUrl">
  <div class="share-card-container">
    <button class="new-link-btn" (click)="createNewLink()">
      + Create New Link
    </button>
    <app-share-card [url]="shortUrl"></app-share-card>
    <app-share-card-options
      [isOneTimeView]="isOneTimeView"
      [hasPin]="hasPin"
      [isCreator]="true"
      [showDeleteOption]="true"
      [showWarnings]="true"
      [currentUrl]="shortUrl"
      (onDelete)="deleteShortUrl()"
    ></app-share-card-options>
  </div>
</div>
<app-faq [items]="faqItems" *ngIf="!isRedirect && !showShareCard"></app-faq>
